import { render, staticRenderFns } from "./CustomerInvoices3.vue?vue&type=template&id=1361b59c&scoped=true&"
import script from "./CustomerInvoices3.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoices3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361b59c",
  null
  
)

export default component.exports